<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="toc" id="toc">
<h1 class="ctfm"><a class="page" id="pv"></a>CONTENTS</h1>
<p class="tocfm"><a class="xref" href="#/chicohenmove0006#intro">Introduction</a></p>
<p class="toc"><a class="xref" href="#/chicohenmove0007#ch01">ONE / Hallways and Airwaves: Changing Neighborhoods and Emerging Media Inspire New Music</a></p>
<p class="toc"><a class="xref" href="#/chicohenmove0008#ch02">TWO / I’m a-Telling You: Artists and Entrepreneurs Step Up in a New Decade</a></p>
<p class="toc"><a class="xref" href="#/chicohenmove0009#ch03">THREE / We’re a Winner: Musicians, Activists, and Educators Build an Expanding Industry</a></p>
<p class="toc"><a class="xref" href="#/chicohenmove0010#ch04">FOUR / Psychedelic Soul: Chicago’s 1960s Counterculture Redirects Social and Musical Cues</a></p>
<p class="toc"><a class="xref" href="#/chicohenmove0011#ch05">FIVE / A New Day: Afrocentric Philosophy and Sharp Statements Answer 1960s Challenges</a></p>
<p class="toc"><a class="xref" href="#/chicohenmove0012#ch06">SIX / Rhythm Ain’t All We Got: Organizational Drive Shapes 1970s Black Music, Commerce, and Politics</a></p>
<p class="toc"><a class="xref" href="#/chicohenmove0014#ch07">SEVEN / Sound Power: Funk and Disco Highlight Connections, Divisions, and Aspirations</a></p>
<p class="toc"><a class="xref" href="#/chicohenmove0015#ch08">EIGHT / Future Telling: Reissues, Sampling, and Young Artists Reconsider Soul History</a></p>
<p class="tocbmf"><a class="page" id="pvi"></a><a class="xref" href="#/chicohenmove0013#gallery">Gallery</a></p>
<p class="tocbm"><a class="xref" href="#/chicohenmove0016#acknow">Acknowledgments</a></p>
<p class="tocbm"><a class="xref" href="#/chicohenmove0017#app">Appendix: Interviews</a></p>
<p class="tocbm"><a class="xref" href="#/chicohenmove0018#notes">Notes</a></p>
<p class="tocbm"><a class="xref" href="#/chicohenmove0019#disco">Selected Discography</a></p>
<p class="tocbm"><a class="xref" href="#/chicohenmove0020#sel_bib">Selected Bibliography</a></p>
<p class="tocbm"><a class="xref" href="#/chicohenmove0021#index">Index</a></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-cohen-move-0005.vue?37c992e8